module.exports = __webpack_public_path__ + "static/landing-30a9fc42f9ab97b2de19a310eefb8126.png";